import { useState } from 'react';
import { Avatar, Button, Drawer, Dropdown, Layout, Menu } from 'antd';
import { UserOutlined, MenuOutlined } from '@ant-design/icons';
import { Link, useHistory } from 'react-router-dom';

import MenuTopics from '../container/MenuTopics';
import AppRoutes from '../routes';

import '../styles/Navbar.less';
import '../styles/Sidebar.less';

const { Header, Content, Footer, Sider } = Layout;

const AdminLayout = () => {
  const history = useHistory();

  const [navIsVisible, setNavIsVisible] = useState(false);

  const closeSidenav = () => {
    setNavIsVisible(false);
  };

  const logout = () => {
    localStorage.clear();
    history.push('/login');
  };

  const openSidenav = () => {
    setNavIsVisible(true);
  };

  const menu = (
    <Menu>
      <Menu.Item key='1'>
        Profile <Link to='/admin/profile' />
      </Menu.Item>
      <Menu.Item key='2'>
        Settings <Link to='/admin/profile' />
      </Menu.Item>
      <Menu.Item key='3' onClick={logout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout>
      <Drawer title='RadMe' placement='left' onClose={closeSidenav} visible={navIsVisible}>
        <MenuTopics onClick={closeSidenav} />
      </Drawer>

      <Sider breakpoint='lg' collapsedWidth='0' trigger={null} className='sidebar-layout'>
        <div className='logo'>RadMe</div>
        <MenuTopics onClick={() => {}} />
      </Sider>

      <Layout>
        <Header className='site-layout-sub-header-background '>
          <Button className='menu' type='primary' icon={<MenuOutlined />} onClick={openSidenav} />
          <Dropdown className='logout-btn' overlay={menu} placement='topRight' arrow trigger={['click']}>
            <Avatar style={{ backgroundColor: '#005F73', cursor: 'pointer' }} icon={<UserOutlined />} />
          </Dropdown>
        </Header>
        <Content style={{ margin: '24px 16px 0' }}>
          <div className='site-layout-background' style={{ padding: '12px 24px', minHeight: 800 }}>
            <AppRoutes />
          </div>
        </Content>
        <Footer style={{ textAlign: 'center', marginTop: '3em' }}>RadMe ©{new Date().getFullYear()} Created by NanoSoft</Footer>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
